import './patient-summary-dashboard.scss';

import { Card, Flex } from 'antd';

import { Title } from 'components/mvp-typography';
import {
  SymptomCard2ContextProvider,
  useCreateSymptomCardContextState
} from '../_components/symptom-card/symptom-card-2';
import { usePatientInfoContext } from '../_utils/patient-info/hook-context-patientinfo';
import { ConcussionSummary } from '../patient-home/components/patient-home-clinician/components/cards/card-concussion-summary';
import { AdministrationSchedule } from './components/displays/display-administration-schedule';
import { DisplayBrainfunctionCategories } from './components/displays/display-brainfunction-categories';
import { DisplayBrainfunctionGrid } from './components/displays/display-brainfunction-grid';
import {
  DisplayConcussionComplexityProgression,
  DisplayTotalSymptomTracker
} from './components/displays/display-total-symptom-tracker';

export function PatientSummaryDashboard() {
  const symptomCard2ContextState = useCreateSymptomCardContextState();
  const patientInfo = usePatientInfoContext();

  return (
    <SymptomCard2ContextProvider value={symptomCard2ContextState}>
      <section className="patient-dashboard">
        <Flex vertical gap="large" className="patient-dashboard-cardcontainer">
          <Card>
            <AdministrationSchedule />
          </Card>
          {
            /**
             * Only render this card if there is concussion data
             * 
             * WARNING: We need to use the ID to hide the field because `initialData` populates the object
             */
            patientInfo.patientInfo.concussion?.id !== "" && (
              <Card>
                <Title level={2}>Concussion Complexity</Title>
                <br />
                <Flex gap={'large'} vertical wrap>
                  <ConcussionSummary noViewDetailsButton noTitle />
                  <Flex gap={'small'} justify="space-between" wrap>
                    <DisplayTotalSymptomTracker width={500} />
                    <DisplayConcussionComplexityProgression width={500} />
                  </Flex>
                </Flex>
              </Card>
            )
          }

          <br />
          <DisplayBrainfunctionGrid />
          <br />
          <Card>
            <DisplayBrainfunctionCategories />
          </Card>
        </Flex>
      </section>
    </SymptomCard2ContextProvider>
  );
}
